const getTelLinkFromPhone = (phone) => "tel:+55" + phone.replace(/[^0-9]/g, "");

const getWhatsappLinkFromPhone = (phone) =>
  "https://wa.me/55" + phone.replace(/[^0-9]/g, "");

/**
 * Obter código do vído do youtube por sua URL.
 *
 * @param {string} url
 */
const getYoutubeCode = (url) => {
  url = new URL(url);

  let code;
  switch (url.host) {
    case "www.youtube.com":
      code = url.searchParams.get("v");
      break;
    case "youtu.be":
      code = url.pathname.replace(/\/(.+)\/?.*/, "$1");
      break;
  }
  return code;
};

/**
 * Formatar string para URL.
 */
const formatToURL = (str) =>
  str
    .normalize("NFD")
    .replace(/\s+/g, "-")
    .replace(/([\u0300-\u036f]|[^0-9a-zA-Z-])/g, "")
    .toLocaleLowerCase();

export {
  getTelLinkFromPhone,
  getWhatsappLinkFromPhone,
  getYoutubeCode,
  formatToURL,
};
